export const initBkashPayment = (orderId: string) => {
  window.open(orderId, "_self");
};
